/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import { Button as c } from "@progress/kendo-react-buttons";
import { onDownPreventDefault as p } from "./utils.mjs";
import { EditorDialogs as d } from "../dialogs/index.mjs";
import { registerForLocalization as D, provideLocalizationService as u } from "@progress/kendo-react-intl";
import { messages as h } from "../messages/index.mjs";
var n;
((m) => {
  m.createViewHtmlTool = (e) => {
    const i = class extends t.Component {
      constructor() {
        super(...arguments), this.state = {
          openedDialog: !1
        }, this.toggleDialog = () => {
          this.setState({
            openedDialog: !this.state.openedDialog
          });
        };
      }
      render() {
        const { view: o, render: r, ...l } = this.props, g = u(this), a = e.messages.viewHtml, s = [
          /* @__PURE__ */ t.createElement(
            c,
            {
              onClick: this.toggleDialog,
              key: "viewHtml",
              ...p,
              title: g.toLanguageString(a, h[a]),
              ...e.props,
              ...l
            }
          ),
          this.state.openedDialog && o && /* @__PURE__ */ t.createElement(
            d.ViewHtmlDialog,
            {
              key: "viewHtmlDialog",
              view: o,
              settings: e,
              dir: l.dir,
              onClose: this.toggleDialog
            }
          ) || null
        ];
        return r ? r.call(void 0, s, { view: o }) : s;
      }
    };
    return D(i), i;
  };
})(n || (n = {}));
export {
  n as ViewHtmlToolNS
};
